import { agentsFAQs } from '@sly/core/constants/agents';

import FAQTile from './FAQTile';

export default function FAQContent() {
  const [firstFAQ, ...restFAQ] = agentsFAQs;
  return (
    <>
      <FAQTile
        className={agentsFAQs.length === 1 ? 'border-t-0' : 'border-0'}
        title={firstFAQ.title}
        description={firstFAQ.description}
      />
      {restFAQ.map((faq) => (
        <FAQTile
          key={faq.title}
          title={faq.title}
          description={faq.description}
        />
      ))}
    </>
  );
}
